import React, { Component } from "react";

import { Link } from "react-router-dom";

import { connect } from "react-redux";

import { sendMessage } from "../store/actions/authActions";

import Logo from "../assets/images/logo.png";
import Menu from "../assets/svg/menu-light.svg";

import MenuFunc from "./Menu";

import { withAlert } from "react-alert";
import { Helmet } from "react-helmet";

class Support extends Component {
  constructor(props) {
    super(props);

    this.state = {
      menuToggled: false,
      message: "",
      email: props.profile.email || "",
      id: props.auth.uid,
    };
  }

  handleChange = (e) => {
    this.setState({
      [e.target.id]: e.target.value,
    });
  };

  componentDidMount() {
    this.setState({ ...this.props.profile });
  }
  componentDidUpdate(previousProps, previousState) {
    if (previousProps.profile !== this.props.profile) {
      this.setState({ ...this.props.profile });
    }
  }

  setmenuoff = (wot) => {
    this.setState({ menuToggled: wot });
  };

  handleSubmit = (e) => {
    e.preventDefault();
    this.props.sendMessage(this.state);
    this.props.alert.show(
      "Nous avons reçu votre message! Nous reviendrons vers vous au plus vite."
    );

    this.setState({ message: "" });
    //this.props.history.push("/");
  };

  render() {
    //const { alert } = this.props;

    return (
      <div>
        <Helmet>
          <title>Support</title>
          <meta
            name="description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />

          <meta property="og:url" content="https://www.boxfit-fitness.com/account" />
          <meta property="og:title" content="BoxFit" />
          <meta
            property="og:description"
            content="Boxfit est l'application web ultime pour les entraînements à la maison avec plus de 390 vidéos, 10 catégories différentes d'exercice et fonctionnalités premium, et l'historique de vos entraînements & Radar de poids."
          />
          <meta property="og:site_name" content="BoxFit" />
          <meta
            property="og:image"
            content="https://www.boxfit-fitness.com/images/sharer.png"
          />
          <meta property="og:type" content="profile" />
          <meta property="og:locale" content="en_US" />
        </Helmet>
        <div style={{ position: "relative" }}>
          <MenuFunc display={this.state.menuToggled} off={this.setmenuoff} />

          <div
            style={{
              zIndex: 999,
              position: "absolute",
              top: "15px",
              left: "20px",
            }}
          >
            <Link
              to={{
                pathname: "/",
                query: {
                  fromMenu: true,
                },
              }}
            >
              <img src={Logo} alt="logo" style={{ maxHeight: "45px" }}></img>
            </Link>
          </div>

          <div
            style={{
              position: "absolute",
              top: "25px",
              right: "22px",
              zIndex: 999,
            }}
            onClick={() => {
              this.setmenuoff(true);
            }}
          >
            <img src={Menu} alt="logo" style={{ maxHeight: "25px" }}></img>
          </div>
        </div>

        <div
          className="Screen"
          style={
            {
              /*height: "800px",
            width: "450px",
            borderRadius: "20px",
            boxShadow: "2px 2px 120px rgba(255, 255, 255, 0.15)",
            backgroundColor: "#000",*/
            }
          }
        >
          <div>
            <div style={{ height: "60px" }}></div>
            <div style={{ padding: "0px 20px 20px 20px" }}>
              <h2
                style={{
                  fontSize: "22px",
                  color: "#69C9D0",
                  borderRadius: "2px",
                }}
              >
                Contact support:
              </h2>

              <form onSubmit={this.handleSubmit} className="">
                <div className="wrappert">
                  <input
                    style={{
                      width: "100%",
                      height: "50px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    type="text"
                    placeholder="Entrez votre email"
                    required
                    id="email"
                    onChange={this.handleChange}
                    value={this.state.email}
                  />
                </div>
                <div style={{ height: "20px" }}></div>

                <div className="wrappert">
                  <textarea
                    style={{
                      width: "100%",
                      height: "90px",
                      fontSize: "18px",
                      padding: "8px",
                      border: 0,
                      borderRadius: "4px",
                    }}
                    placeholder="Entrez votre message"
                    type="text"
                    required
                    id="message"
                    onChange={this.handleChange}
                    value={this.state.message}
                  />
                </div>

                <div style={{ height: "20px" }}></div>

                <button
                  style={{
                    fontSize: "18px",
                    background: "#EE1D52",
                    padding: "10px",
                    border: 0,
                    borderRadius: "4px",
                    fontWeight: "600",
                    width: "100%",
                    color: "white",
                  }}
                  onClick={() => {
                    this.setState({ finished: false });
                  }}
                >
                  <span role="img" aria-label="like">
                    👉
                  </span>{" "}
                  Requête au Support
                </button>
              </form>
              <div style={{ height: "20px" }}></div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return { auth: state.firebase.auth, profile: state.firebase.profile };
};

const mapDispatchToProps = (dispatch) => {
  return {
    sendMessage: (obj) => dispatch(sendMessage(obj)),
  };
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withAlert()(Support));
